import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Compass } from 'lucide-react';
import { Button } from '@/components/ui/button';

/** Routed outside MainLayout, so it carries the island itself. */
const NotFoundPage: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <main className="revy-ui flex min-h-screen flex-col items-center justify-center gap-4 bg-background px-6 text-center text-foreground">
      <span className="grid size-14 place-items-center rounded-2xl bg-primary/10 text-primary">
        <Compass className="size-7" strokeWidth={1.7} />
      </span>

      <p className="revy-figure text-6xl font-semibold leading-none tracking-tight text-primary">
        404
      </p>

      <h1 className="revy-cjk text-xl font-semibold leading-[1.5]">{t('errors.notFound')}</h1>

      <p className="revy-cjk max-w-md text-sm leading-[1.6] text-muted-foreground">
        {t('errors.pageNotFoundDescription')}
      </p>

      <Button
        onClick={() => navigate('/')}
        className="mt-2 transition-[scale] active:scale-[0.96] motion-reduce:active:scale-100"
      >
        {t('common.goHome')}
      </Button>
    </main>
  );
};

export default NotFoundPage;
